import { FavoritesContext } from './contexts/FavoritesContext';
import { useContext, useEffect, useState } from 'preact/hooks';

export default function FavoriteButton({ id }) {
	const { favorites, setFavoriteToUpdate } = useContext(FavoritesContext);

	const [isFavorited, setIsFavorited] = useState(false);

	useEffect(() => {
		if (favorites.includes(id)) {
			setIsFavorited(true);
		} else {
			setIsFavorited(false);
		}
	}, [favorites, id]);

	return (
		<button
			class={`bg-dark text-white h-9 w-9 hover:text-yellow text-lg ${
				isFavorited ? 'text-yellow' : 'text-white'
			}`}
			onClick={() => setFavoriteToUpdate(id)}
		>
			{isFavorited ? (
				<i class="fas fa-heart"></i>
			) : (
				<i class="far fa-heart"></i>
			)}
		</button>
	);
}
